export default function (index) {
  const chart_bar_scheme = [
    '#6A88AA', // base blue
    '#6AAA6C', // comp green
    '#aa6aa8', // comp purpl
    '#aa8c6a', // comp light brown
    '#aa6a88', // sec purpl
    '#88aa6a', // sec green
    '#6aa8aa', // tert blue
    '#a8aa6a', // tert brown
    '#769484', // other teal
    '#995555', // other brown
  ];
  let newIndex = index;

  while (newIndex > chart_bar_scheme.length) {
    newIndex = newIndex - 10;
  }

  return chart_bar_scheme[newIndex];
}
